export default __webpack_public_path__ + "static/media/sc1.8c38951e.png";